import {

	ConnectWalletArtworkc1,
	ConnectWalletAuthors2,
	ConnectWalletArtworkc2,
	ConnectWalletAuthors3,
	ConnectWalletArtworkc3,
	ConnectWalletAuthors4,
	ConnectWalletArtworkc4,
	ConnectWalletAuthors5,
	ConnectWalletAuthors6,
	ConnectWalletAuthors7,
	ConnectWalletAuthors8,
	ConnectWalletAuthors9,

} from '../../utils/allImgs'

export const Authors = [
	{
		imgBig:ConnectWalletArtworkc1,
		imgSm:ConnectWalletAuthors2,
		name:'Morgan Wright'
	},
	{
		imgBig:ConnectWalletArtworkc2,
		imgSm:ConnectWalletAuthors3,
		name:'Sendos Ali'
	},
	{
		imgBig:ConnectWalletArtworkc3,
		imgSm:ConnectWalletAuthors4,
		name:'Kamilia Norsh'
	},
	{
		imgBig:ConnectWalletArtworkc4,
		imgSm:ConnectWalletAuthors5,
		name:'Semova Altena'
	},
	{
		imgBig:ConnectWalletArtworkc1,
		imgSm:ConnectWalletAuthors6,
		name:'Naretor-Nole'
	},
	{
		imgBig:ConnectWalletArtworkc2,
		imgSm:ConnectWalletAuthors7,
		name:'Johan Donem'
	},
	{
		imgBig:ConnectWalletArtworkc3,
		imgSm:ConnectWalletAuthors8,
		name:'Amillia Nnor'
	},
	{
		imgBig:ConnectWalletArtworkc4,
		imgSm:ConnectWalletAuthors9,
		name:'LarySmith-30'
	},
]
